import { useNavigate } from 'react-router-dom';

export const useNavigateOnEdit = (id: number): (() => void) => {
  const navigate = useNavigate();
  return () => {
    navigate({ pathname: `edit/${id}/releases` });
  };
};
